import * as vanilla from 'OK/utils/vanilla';
import * as dom from 'OK/utils/dom';

function onButtonKeyPress(e: KeyboardEvent) {
    if ((e.code === 'Enter' || e.code === 'Space') && !e.ctrlKey && !e.shiftKey && !e.altKey) {
        if (e.target instanceof HTMLElement) {
            switch (e.target.tagName) {
                case 'INPUT':
                case 'BUTTON':
                case 'TEXTAREA':
                    // браузер сам обработает
                    return;
            }
        }
        e.preventDefault(); // предотвращаем скролл
        vanilla.trigger(e.target as HTMLElement, 'click');
    }
}

export function activateButton(el: HTMLElement) {
    el.addEventListener('keypress', onButtonKeyPress);
}

export function deactivateButton(el: HTMLElement) {
    el.removeEventListener('keypress', onButtonKeyPress);
}

function isInvisible(el: Element) {
    const invisibleEl = dom.traverseParents(el, testEl => {
        return window.getComputedStyle(testEl).visibility !== 'visible';
    }, null, true);
    return invisibleEl !== null;
}

export function isVisible(el: Element, checkVisibility = false) {
    if (checkVisibility && isInvisible(el)) {
        return false;
    }
    if (el instanceof HTMLElement && el.offsetParent !== null) {
        return true;
    }
    // Element или offsetParent null для position: fixed
    const { height, width } = el.getBoundingClientRect();
    return height && width;
}

export function isInputText(el: Element) {
    switch (el.tagName) {
        case 'TEXTAREA':
            return true;
        case 'INPUT':
            return (el as HTMLInputElement).type === 'text';
        case 'DIV':
            return (el as HTMLDivElement).contentEditable === 'true';
        default:
            return false;
    }
}

export function focusToInput(input: HTMLElement, cursorToEnd = false) {
    if (!isInputText(input)) {
        return;
    }

    input.focus();

    if (!cursorToEnd) {
        return;
    }

    switch (input.tagName) {
        case 'TEXTAREA':
        case 'INPUT':
            const it = (input as HTMLInputElement);
            it.selectionStart = it.value.length;
            break;
        case 'DIV':
            const selection = window.getSelection()!;
            const rangeOfEndContent = selection.getRangeAt(0);

            const lastLine = input.lastChild;

            if (lastLine) {
                if (lastLine instanceof HTMLBRElement) {
                    rangeOfEndContent.setStart(lastLine, 0);
                    rangeOfEndContent.setEnd(lastLine, 0);
                } else {
                    if (lastLine.nodeType === 3) {
                        rangeOfEndContent.setStart(lastLine, lastLine.nodeValue?.length!);
                        rangeOfEndContent.setEnd(lastLine, lastLine.nodeValue?.length!);
                    } else {
                        rangeOfEndContent.setStartAfter(lastLine);
                        rangeOfEndContent.setEndAfter(lastLine);
                    }
                }
            }
            break;
    }
}
